// extracted by mini-css-extract-plugin
module.exports = {"avatar":"User_avatar__1aV44","name":"User_name__3_cPa","emailOption":"User_emailOption__1jn69","icon":"User_icon__31lsP","logout":"User_logout__3C4rM"};